// Splide init
function mmInitSplide() {
	var id = ".mm-cart-cross-sell-splide";
    var splideElem = document.querySelector(id);
	
	if (splideElem && !splideElem.hasAttribute('data-splide-initialized')) {
		var bar = splideElem.querySelector(".my-carousel-progress-bar");
		var crossSellSplide = new Splide(splideElem, {
			type: 'slide',
			arrows: false,
			pagination: false,
			gap: 0,
			perMove: 1,
			fixedWidth: 290,
			omitEnd: true,
		})

		crossSellSplide.on("mounted move", function () {
			var end = crossSellSplide.Components.Controller.getEnd() + 1;
			var rate = Math.min((crossSellSplide.index + 1) / end, 1);
			if (bar) {
				bar.style.width = String(100 * rate) + "%";
			}
		});
		crossSellSplide.mount();
		//splideElem.setAttribute('data-splide-initialized', 'true');
	}
	console.log('splide initialized')
};

document.addEventListener(
    "DOMContentLoaded",
    () => {
        mmInitSplide();
		ecoPartSum();
		sendDeliveryInstructions();
		initDeliveryDateButton();
        //mmOpenCart();
    },
    { once: true }
);

/**
 * Creates a debounced function that delays invoking func until after duration milliseconds have elapsed since the last time the debounced function was invoked.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} duration - The number of milliseconds to delay.
 * @returns {Function} - The debounced function.
 */
function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

/**
 * Get the cart product container element from the cart section.
 *
 * @returns {HTMLElement} - The cart product container element.
 */
function mmCartProductsContainerElement() {
    return document.querySelector('.mm-cart-container');
}

/**
 * Get the cart item element for a specific product variant.
 *
 * @param {number} productVariantId - The product variant ID.
 * @returns {HTMLElement} - The cart item element.
 */
function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

/**
 * Get the cart item quantity element for a specific product variant.
 *
 * @param {number} productVariantId - The product variant ID.
 * @returns {HTMLElement} - The cart item quantity element.
 */
function mmCartItemQuantityEl(productVariantId) {
    const itemEl = mmCartItem(productVariantId);
    return itemEl.querySelector('[data-item-quantity]');
}

/**
 * Get the quantity of a specific cart item.
 *
 * @param {number} productVariantId - The product variant ID.
 * @returns {number} - The quantity of the cart item.
 */
function mmGetCartItemQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);
    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

/**
 * Set the quantity of a specific cart item and update the DOM.
 *
 * @param {number} productVariantId - The product variant ID.
 * @param {number} newQuantity - The new quantity to set.
 */
function mmSetCartItemQuantity(productVariantId, newQuantity) {
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(productVariantId);
        quantityEl.dataset.itemQuantity = newQuantity;
        
        // Vérifier s'il y a un quantity_per_bundle
        const quantityPerBundleEl = quantityEl.closest('.mm-dc-product-qqty').querySelector('[data-quantity-per-bundle]');
        if (quantityPerBundleEl) {
            const quantityPerBundle = parseInt(quantityPerBundleEl.dataset.quantityPerBundle, 10);
            quantityEl.innerText = Math.floor(newQuantity / quantityPerBundle);
        } else {
            quantityEl.innerText = newQuantity;
        }
    }
}

/**
 * Create a new cart element from the provided data.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The new cart element.
 */
function mmCartHTMLFromData(data) {
    const el = document.createElement('DIV');
    el.innerHTML = data.sections[mmCartSectionId()];
    return el;
}

/**
 * Extract the items container from the new cart HTML.
 *
 * @param {Object} data - The data containing cart HTML.
 * @returns {HTMLElement} - The items container element.
 */
function extractItemsFromCartHTML(data) {
    const el = mmCartHTMLFromData(data);
    return el.querySelector('.mm-dc-products-container');
}

/**
 * Insert cart products from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 **/
function insertCartProductsFromResponse(data) {
    const itemsContainer = extractItemsFromCartHTML(data);
    mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;
    return data;
}

/**
 * Extract the total price element from the new cart HTML.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {HTMLElement} - The total price element.
 */
function extractTotalPriceFromCartHTML(data) {
    const cartEl = mmCartHTMLFromData(data);
    return cartEl.querySelector('[data-cart-total-price]');
}

/**
 * Insert the total price from the response data into the current cart in the DOM.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function insertInsertTotalPriceFromResponse(data) {
    const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
    const currentTotalPriceEl = document.querySelector('[data-cart-total-price]');
    currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;
    return data;
}

/**
 * Perform an API request to fetch or update cart data.
 *
 * @param {string} method - The HTTP method (GET, POST, etc.).
 * @param {string} path - The API endpoint path.
 * @param {Object} body - The request body data.
 * @returns {Promise<Object>} - A promise resolving to the response data.
 */
function mmAPIRequest(method, path, body) {
    document.querySelector('.mm-dc-products')?.classList?.add('mm-inactive');
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            updateCartCount();
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

/**
 * Fetch the current cart data.
 *
 * @returns {Promise<Object>} - A promise resolving to the cart data.
 */
function mmGetCart() {
    return mmAPIRequest('GET', 'cart.js');
}

/**
 * Re-render the cart inner HTML from the response data and initialize Splide carousels.
 *
 * @param {Object} data - The data containing the new cart HTML.
 * @returns {Object} - The response data.
 */
function refreshCartFromData(data) {
    const newCartEl = document.createElement('DIV');
    newCartEl.innerHTML = data.sections[mmCartSectionId()];

    // Safety net: if the date form is visible in the new HTML, the delivery date
    // product is no longer in the cart — clear any stale mm_date from localStorage.
    if (newCartEl.querySelector('.mm-cart-delivery-date') && localStorage.getItem("mm_date")) {
        localStorage.removeItem("mm_date");
    }

    const innerCart = document.querySelector('.mm-cart-container');
	const crossSellMobile = innerCart.querySelector('.mm-cart-cross-sell')
	if (crossSellMobile && crossSellMobile.classList.contains('mm-show')){
		console.log(newCartEl);
		newCartEl.querySelector('.mm-cart-cross-sell').classList.add('mm-show');
	}
    innerCart.innerHTML = newCartEl.querySelector('.mm-cart-container').innerHTML;
	changeCrossSellCtaText();
    mmInitSplide();
	ecoPartSum();
	updateCartCount();
	adjustCartHeight();
    mmGetRecoProductsForCrossSell();
	if (typeof mmInitPaymentOptions === 'function') mmInitPaymentOptions('cart');
	sendDeliveryInstructions();
	getValuesFromLocalStorage();
	initDeliveryDateForm();
    return data;
}

function mmCartSectionIdLong() {
	return document.querySelector('.mm-cart-wrapper').id;
}

function mmCartSectionId() {
	return document.querySelector('.mm-cart-wrapper').id.replace('shopify-section-', '');
}

/**
 * Add a product to the cart and optionally open the cart drawer.
 *
 * @param {number} productId - The product ID to add.
 * @param {Object} options - Options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
 */
function mmAddProductToCart(productId, { quantity = 1, openCart = false }) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: [
                {
                    id: productId,
                    quantity: quantity,
                },
            ],
			// sections: mmCartSectionId(),
        }),
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to add product to cart');
        }
        return response.json();
    })
    .then(data => {
        console.log('Product successfully added to cart:', data);
        if (openCart) {
            showCart();
        }
		// refreshCartFromData(data);
		updateCartCount()
    })
    .catch(error => {
        console.error('Erreur lors de l’ajout au panier:', error);
    });
}

function mmAddProductCrossSellToCart(productId, { quantity = 1, openCart = false }) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            items: [
                {
                    id: productId,
                    quantity: quantity,
                },
            ],
			sections: mmCartSectionId(),
        }),
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Failed to add product to cart');
        }
        return response.json();
    })
    .then(data => {
        console.log('Product successfully added to cart:', data);
        if (openCart) {
            showCart();
        }
		refreshCartFromData(data);
    })
    .catch(error => {
        console.error('Erreur lors de l’ajout au panier:', error);
    });
}

function mmRefreshForm() {
	const event = new Event("change");
	const productForm = document.querySelector('variant-selector');
	if(productForm) {
		productForm.dispatchEvent(event);    
	}
}

/**
 * Increase the quantity of a specific product in the cart by one.
 *
 * @param {number} productVariantId - The product variant ID.
 */
function mmIncreaseProductQuantity(productVariantId) {
	const itemCart = mmCartItem(productVariantId);
    const quantity = mmGetCartItemQuantity(productVariantId);
	const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
    let newQuantity = 0;
	const quantityPerBundle = itemCart.querySelector('[data-quantity-per-bundle]');
	if(quantityPerBundle) {
		newQuantity = quantity + (1 * quantityPerBundle.dataset.quantityPerBundle);
	}else{
		newQuantity = quantity + 1;
	}
	console.log('newQuantity', newQuantity)

	if (newQuantity > maxQtty) {
        return;
    }

    mmSetCartItemQuantity(productVariantId, newQuantity);
    mmDebouncedPushNewQuantity(productVariantId);
}

/**
 * Decrease the quantity of a specific product in the cart by one.
 *
 * @param {number} productVariantId - The product variant ID.
 */
function mmDecreaseProductQuantity(productVariantId) {
	const itemCart = mmCartItem(productVariantId);
    const quantity = mmGetCartItemQuantity(productVariantId);
	const maxQtty = parseInt(itemCart.dataset.maxQuantity, 10);
    let newQuantity = 0;
	const quantityPerBundle = itemCart.querySelector('[data-quantity-per-bundle]');
	if(quantityPerBundle) {
		newQuantity = quantity - (1 * quantityPerBundle.dataset.quantityPerBundle);
	}else{
		newQuantity = quantity - 1;
	}

	console.log('newQuantity', newQuantity)
    console.log('maxQtty', maxQtty)

    if (newQuantity > maxQtty) {
        return;
    }

    if (newQuantity <= 0 && itemCart.dataset.isDeliveryDateProduct) {
        localStorage.removeItem("mm_date");
    }

    mmSetCartItemQuantity(productVariantId, newQuantity);
    mmDebouncedPushNewQuantity(productVariantId);
}

/**
 * Remove a specific product from the cart.
 *
 * @param {number} productVariantId - The product variant ID.
 */
function mmDestroyProductFromCart(productVariantId) {
    const itemCart = mmCartItem(productVariantId);
    if (itemCart && itemCart.dataset.isDeliveryDateProduct) {
        mmCancelDeliveryDate(productVariantId);
        return;
    }
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);
    mmDebouncedPushNewQuantity(productVariantId);
}

/**
 * Cancel the deferred delivery: remove the delivery date product from the cart
 * and clear the stored delivery date from localStorage.
 *
 * @param {number} productVariantId - The delivery date product variant ID.
 */
function mmCancelDeliveryDate(productVariantId) {
    localStorage.removeItem("mm_date");
    mmAPIRequest("POST", "cart/change.js", {
        id: productVariantId.toString(),
        quantity: 0,
        sections: mmCartSectionId(),
    })
    .then(refreshCartFromData);
}

function mmDestroyXSellItemFromCart(productVariantId) {
	console.log("productVariantId",productVariantId);

    mmAPIRequest("POST", "cart/change.js", {
        id: productVariantId.toString(),
        quantity: 0,
        sections: mmCartSectionId(),
    })
    .then(refreshCartFromData);
}

/**
 * Push the new quantity of a specific product to the server.
 *
 * @param {number} productVariantId - The product variant ID.
 */
function mmPushNewQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    mmAPIRequest('POST', 'cart/change.js', {
        id: productVariantId.toString(),
        quantity: quantity,
        sections: mmCartSectionId(),
    })
    .then(refreshCartFromData);
}

/**
 * Debounced function to push new quantity of a specific product to the server.
 *
 * @param {number} productVariantId - The product variant ID.
 */
const mmDebouncedPushNewQuantity = debounce(function (productVariantId, maxQtty) {
	const quantity = mmGetCartItemQuantity(productVariantId);
    console.log('quantity', quantity)

	if (quantity > maxQtty) {
        return;
    }
	
    mmPushNewQuantity(productVariantId);
}, 300);

/**
 * Add a free product to the cart and optionally open the cart drawer.
 *
 * @param {number} productId - The free product ID to add.
 * @param {Object} options - Options for adding the product.
 * @param {number} [options.quantity=1] - The quantity to add.
 * @param {boolean} [options.openCart=true] - Whether to open the cart drawer after adding the product.
 * @param {HTMLElement} clickedElem - The element that was clicked to trigger this action.
 */
function mmAddFreeProductToCart(productId, { quantity = 1, openCart = true }, clickedElem) {
    // Debounce on the CTA
    clickedElem.innerText = 'AJOUTÉ !';
    clickedElem.classList.add('mm-disabled');

    // Ajouter le free product
    mmAddProductToCart(productId, { openCart: false });
}

/**
 * Update the cart count bubble with the given value.
 *
 * @param {number} value - The new cart count value.
 */
function updateCartCount() {
	fetch('/cart.js')
	.then(response => response.json())
	.then(data => {
		const value = data.item_count;
		if (value > 0) {
			document.querySelector('.mm-cart-count-bubble').classList.remove('mm-none');
			document.querySelector('.mm-cart-count-bubble').innerText = value;
		} else {
			document.querySelector('.mm-cart-count-bubble').classList.add('mm-none');
		}
	})
	.catch(error => {
		console.error('Erreur lors de la récupération du panier:', error);
	});
}

window.addEventListener('DOMContentLoaded', (event) => {
    mmGetCart();
});

// Upsell cart page
function mmChangeProductToNextSize(clickedElem, variant_id_to_remove, variant_id_to_add, add_property) {
	clickedElem.classList.add('mm-loading');
	const productIdToAdd = parseInt(variant_id_to_add, 10);
	const item_card = clickedElem.closest('.mm-dc-product-container');
	const quantity = item_card.querySelector('.mm-dc-product-qqty-number').dataset.itemQuantity;

	// Supprimer l'ancien produit (variant_id_to_remove)
	mmAPIRequest('POST', 'cart/change.js', {
		id: variant_id_to_remove,
		quantity: 0,
		sections: mmCartSectionId()
	})
	.then(() => {
		// Une fois le produit supprimé, on ajoute le nouveau produit
		let itemToAdd = {
			quantity: quantity,
			id: productIdToAdd
		};

		// Si add_property est true, ajouter les properties
		if (add_property) {
			itemToAdd.properties = {
				'_downsell': variant_id_to_remove
			};
		}
		return mmAPIRequest('POST', 'cart/add.js', {
			items: [itemToAdd],
			sections: mmCartSectionId()
		});
	})
	.then(refreshCartFromData) // Rafraîchir le panier
	.catch((error) => {
		// Gestion des erreurs
		clickedElem.classList.remove('mm-loading');
		alert("Impossible d'ajouter ce produit au panier - il n'est peut-être plus en stock !");
		console.log(error);
	});
}

function mmChangeCrosSellQuantity(clickeElem, delta) {
	const card = clickeElem.closest('.mm-dc-cs-product-container');
	const valueInput = card.querySelector('.mm-dc-product-qqty-number');
	const price = card.querySelector('[data-product-price]');
	const compare_at_price = card.querySelector('[data-product-compare-at-price]');

	const newValue = parseInt(valueInput.dataset.itemQuantity) + delta;
	if(newValue < 1) {
		valueInput.dataset.itemQuantity = 1;
		valueInput.innerText = 1;    
	} else {
		valueInput.dataset.itemQuantity = newValue;
		valueInput.innerText = newValue;    
	}

	// Change CTA price
	const unit_price = price.dataset.value;
	const new_price = unit_price * newValue / 100;
	price.innerText = `${new_price}€`;
	
	// Change CTA compare at price
	const unit_compare_at_price = compare_at_price.dataset.value;
	const new_compare_at_price = unit_compare_at_price * newValue / 100;
	compare_at_price.innerText = `${new_compare_at_price}€`;
}

// Toaster when add a product to cart
function showCartToast() {
	const toast = document.querySelector('.mm-cart-toast');
	const filter = document.querySelector('.mm-filter-toaster');

	if (!toast) {
		console.error('Toaster HTML manquant ou mal configuré.');
		return;
	}

	toast.classList.add('mm-show');
	filter.classList.add('active');


	setTimeout(() => {
		toast.classList.remove('mm-show');
	}, 5000);
}

function showGroupedToast(productCount = 1, imageUrl = null) {
	const toast = document.querySelector('.mm-cart-toast');
	const filter = document.querySelector('.mm-filter-toaster');

	if (!toast) {
		console.error('Toaster HTML manquant ou mal configuré.');
		return;
	}

		const titleEl = toast.querySelector('.mm-cart-toast-product-title');
	if (titleEl) {
		titleEl.textContent = `${productCount} échantillon${productCount > 1 ? 's' : ''} ajouté${productCount > 1 ? 's' : ''} au panier`;
	}

	// Met à jour l'image si une URL est fournie
	if (imageUrl) {
		const img = toast.querySelector('.mm-cart-toast-content picture img');
		if (img) {
			img.src = imageUrl;
			img.alt = 'Produit ajouté au panier';
		} else {
			console.warn("Image introuvable dans le toaster");
		}
	}

	toast.classList.add('mm-show');
	filter.classList.add('active');

	setTimeout(() => {
		toast.classList.remove('mm-show');
	}, 5000);
}


function hideCartToast() {
	const toast = document.querySelector('.mm-cart-toast');
	const filter = document.querySelector('.mm-filter-toaster');


	toast.classList.remove('mm-show');
	filter.classList.remove('active');
}

// Eco part total
function ecoPartSum() {
	const ecoParts = document.querySelectorAll('[data-item-eco-part]');
	const ecoPartsContainer = document.querySelector('.mm-cart-footer-eco-participation');
	const totalEcoPartDiv = document.querySelector('.mm-cart-footer-eco-participation-total');

	let totalEcoPart = 0;

	ecoParts.forEach((ecoPart) => {
		const value = parseFloat(ecoPart.dataset.itemEcoPart);
		if (!isNaN(value)) {
			totalEcoPart += value;
		}
	});

	totalEcoPart /= 100;

	if (totalEcoPartDiv) {
		totalEcoPartDiv.textContent = `${totalEcoPart.toFixed(2)} €`;
	}

	if (ecoPartsContainer) {
		ecoPartsContainer.style.display = totalEcoPart === 0 ? 'none' : 'block';
	}
}

function showCrossSellMobile(){
	const crossSellMobileContainer = document.querySelector('.mm-cart-cross-sell');

	crossSellMobileContainer.classList.add('mm-show');
	document.querySelector("html").classList.add("stop-scrolling");
}

function hideCrossSellMobile(){
	const crossSellMobileContainer = document.querySelector('.mm-cart-cross-sell');

	crossSellMobileContainer.classList.remove('mm-show');
	document.querySelector("html").classList.remove("stop-scrolling");
}

function changeCrossSellCtaText(){
	const ctaText = document.querySelector('.mm-cart-cross-sell-mobile-bottom .original-content');

	ctaText.textContent ='Finaliser ma commande';
}

// Adjust mobile cart products container
function adjustCartHeight() {
	const cartProducts = document.querySelector('.mm-cart-products');
	// const cartReassuranceRight = document.querySelector('.mm-cart-reassurance-right');
	const cartFooterReassurance = document.querySelector('.mm-cart-footer-reassurance');
	const cartFooter = document.querySelector('.mm-cart-footer');

	if (cartProducts) {
		// Calcule la hauteur totale des trois éléments
		const totalHeight = [
			// cartReassuranceRight,
			cartFooterReassurance,
			cartFooter
		].reduce((sum, element) => {
			return sum + (element ? element.offsetHeight : 0);
		}, 0);

		if (window.innerWidth <= 768) { // Seuil pour le mobile (peut être ajusté)
			cartProducts.style.height = `calc(100svh - ${totalHeight}px + var(--header-height-mobile) + var(--announcement-bar-height-mobile))`;
		} else {
			cartProducts.style.height = ''; // Réinitialiser sur desktop
		}
	}
}

/**
 * Réinitialise les options de paiement après mise à jour du panier
 */
function reinitializePaymentOptions() {
    // Chercher les options de paiement dans le contexte panier
    const cartPaymentOptions = document.querySelector('.mm-payment-options[data-payment-context="cart"]');
    
    if (!cartPaymentOptions) return;
    
    // Réinitialiser les options de paiement
    const installmentOptions = cartPaymentOptions.querySelectorAll('.mm-installment-option');
    const providerDisplay = cartPaymentOptions.querySelector('.mm-provider-name-display');
    const providerLogo = cartPaymentOptions.querySelector('.mm-provider-logo');
    const installmentDetails = cartPaymentOptions.querySelector('.mm-installment-details');
    const installmentAmount = cartPaymentOptions.querySelector('.mm-installment-amount');
    
    if (!installmentOptions.length) return;
    
    // Fonction pour mettre à jour l'affichage (copie de celle du snippet)
    function updateDisplay(option) {
        const provider = option.dataset.provider;
        const installments = parseInt(option.dataset.installments);
        const price = option.dataset.installmentPrice;
        const fees = option.dataset.fees;
        const logo = option.dataset.logo;
        
        // Mettre à jour le provider et le logo selon la disponibilité
        if (logo && logo.trim() !== '') {
            // Logo présent : afficher le logo, masquer le nom
            providerLogo.innerHTML = `<img src="${logo}" alt="${provider} logo" style="width: 70px; height: 35px; object-fit: contain;">`;
            providerLogo.style.display = 'block';
            providerDisplay.style.display = 'none';
        } else {
            // Pas de logo : afficher le nom, masquer le logo
            providerDisplay.textContent = provider;
            providerDisplay.className = `mm-provider-name-display ${provider.toLowerCase()}`;
            providerDisplay.style.display = 'block';
            providerLogo.style.display = 'none';
        }
        
        // Mettre à jour les détails
        installmentAmount.textContent = `${installments} x ${price}${fees ? ` (${fees})` : ''}`;
        installmentDetails.className = `mm-installment-details ${provider.toLowerCase()}`;
    }
    
    // Afficher la première option par défaut
    if (installmentOptions.length > 0) {
        const firstOption = installmentOptions[0];
        firstOption.classList.add('active');
        updateDisplay(firstOption);
    }
    
    // Réattacher les événements
    installmentOptions.forEach(option => {
        // Gestion du survol
        option.addEventListener('mouseenter', function() {
            // Supprimer la classe active de toutes les options
            installmentOptions.forEach(opt => opt.classList.remove('active'));
            // Ajouter la classe active à l'option survolée
            this.classList.add('active');
            // Mettre à jour l'affichage
            updateDisplay(this);
        });
        
        // Gestion du clic pour sélectionner définitivement
        option.addEventListener('click', function() {
            // Supprimer la classe active de toutes les options
            installmentOptions.forEach(opt => opt.classList.remove('active'));
            // Ajouter la classe active à l'option cliquée
            this.classList.add('active');
            // Mettre à jour l'affichage
            updateDisplay(this);
        });
    });
    
    // Gestion de la sortie de souris pour revenir à la première option
    cartPaymentOptions.addEventListener('mouseleave', function() {
        // Revenir à la première option si aucune n'est sélectionnée
        const hasActiveOption = cartPaymentOptions.querySelector('.mm-installment-option.active');
        if (!hasActiveOption && installmentOptions.length > 0) {
            const firstOption = installmentOptions[0];
            firstOption.classList.add('active');
            updateDisplay(firstOption);
        }
    });
    
    console.log('Options de paiement réinitialisées pour le panier');
}

// Ajuste la hauteur au chargement et lors des redimensionnements de la fenêtre
adjustCartHeight();
window.addEventListener('resize', adjustCartHeight);


function getLastWord(title) {
	return title.trim().split(' ').pop().toUpperCase(); // Supprime les espaces inutiles et récupère le dernier mot
  }

  function truncateTitle(title, maxLength = 100) {
	if (title.length > maxLength) {
	  return title.slice(0, maxLength).trim() + '…'; // Tronque à 40 caractères + ajoute une ellipse
	}
	return title; // Retourne le titre si pas besoin de tronquer
  }

// Get cross-sell products from most expensive product recommendations
function getVPDiscount(product) {
	const now = Math.floor(Date.now() / 1000);
	const start = window.themeSettings?.promotion_vp_account_start;
	const end = window.themeSettings?.promotion_vp_account_end;
	const isCustomer = !!window.customer;
  
	if (start && end && now >= start && now <= end && isCustomer && product.tags) {
	  const vpTag = product.tags.find(tag => tag.startsWith('VENTEPRIVEE'));
	  if (vpTag) {
		const discount = parseInt(vpTag.replace('VENTEPRIVEE', ''), 10);
		if (!isNaN(discount) && discount > 0) {
		  const originalPrice = product.price;
		  const discountAmount = Math.round(originalPrice * discount / 100);
		  const finalPrice = originalPrice - discountAmount;
		  return {
			finalPrice,
			discount,
			originalPrice
		  };
		}
	  }
	}
	return null;
  }


	function mmShowLoader() {
		const loader = document.querySelector('.mm-cart-cross-sell-loader');
		loader.classList.remove('mm-none');
		loader.classList.add('mm-flex');
	}

	function mmHideLoader() {
		const loader = document.querySelector('.mm-cart-cross-sell-loader');
		loader.classList.add('mm-none');
		loader.classList.remove('mm-flex');
	}

	function mmGetRecoProductsForCrossSell() {
		const product_id = document.getElementById('mostExpensiveItemId');
		const max_products = document.getElementById('mostExpensiveItemId');
		
		// Vérifier que les éléments existent
		if (!product_id || !max_products) {
			console.log('mostExpensiveItemId not found, skipping cross-sell recommendations');
			return;
		}

		mmShowLoader();
		
		fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${product_id.value}&limit=${max_products.dataset.limit}&intent=complementary`)
		.then(response => response.json())
		.then(({ products }) => {
			if (products.length > 0) {
			const crossSellSliderDesktop = document.querySelector('.mm-cart-cross-sell-splide ul.mm-desktop'); 
			const crossSellSliderMobile = document.querySelector('.mm-cart-cross-sell-splide ul.mm-mobile'); 
			
			// Vérifier que les conteneurs existent
			if (!crossSellSliderDesktop || !crossSellSliderMobile) {
				console.log('Cross-sell containers not found, skipping recommendations');
				mmHideLoader();
				return;
			}
			
			// Vider les conteneurs avant d'ajouter les nouveaux produits
			crossSellSliderDesktop.innerHTML = '';
			crossSellSliderMobile.innerHTML = '';
			
			products.forEach(function(product) {
				// --- LOGIQUE VP ---
				const vp = getVPDiscount(product);
				let priceHtml = '';
				if (vp) {
				priceHtml = `
					<p class="mm-dc-product-price">${(vp.finalPrice / 100).toFixed(2)} €</p>
					<p class="mm-dc-product-compare-at-price"><s>${(vp.originalPrice / 100).toFixed(2)} €</s></p>
					<div class="mm-dc-product-price-reduce mm-flex">
					<p class="mm-product-label mm-badge-sm mm-badge-ratings">-${vp.discount}%</p>
					</div>
				`;
				} else {
				// Logique de prix basée sur le stock (comme dans les fichiers Liquid)
				let displayPrice = product.price;
				if (product.variants[0].inventory_quantity <= 0 && product.compare_at_price) {
					displayPrice = product.compare_at_price;
				}
				
				priceHtml = `<p class="mm-dc-product-price">${(displayPrice / 100).toFixed(2)} €</p>`;
				
				// Afficher le prix barré seulement si il y a du stock et un compare_at_price
				if (product.variants[0].inventory_quantity > 0 && product.compare_at_price > product.price) {
					priceHtml += `<p class="mm-dc-product-compare-at-price"><s>${(product.compare_at_price / 100).toFixed(2)} €</s></p>`;
				}
				}
	
				const product_card = `
					<li class="splide__slide">
						<div class="mm-dc-cross-product mm-h-full mm-align-center mm-flex">
						<a href="${product.url}">
							<img class="mm-dc-cross-product-image" src="${product.featured_image}" alt="${product.title}">
						</a>
						<div class="mm-dc-product-right mm-h-full mm-align-center mm-flex">
							<div class="mm-dc-cross-product-content mm-flex mm-column mm-justify-center">
								<p class="mm-dc-product-title">${getLastWord(product.title)}</p>
								<div class="mm-dc-product-price-container mm-flex mm-align-center">
									${priceHtml}
								</div>
								<div class="mm-dc-product-description">${truncateTitle(product.description)}</div>
							</div>
						</div>
						<span class="mm-dc-cross-product-cta mm-btn mm-btn-tertiary" onclick="mmAddProductCrossSellToCart(${product.variants[0].id}, { openCart: false }); changeCrossSellCtaText()">
							<svg class="mm-icon-add-to-cart" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" style="width: 18px; height: 18px;">
							<path d="M12.2981 6.54768V5.32821C12.2981 4.07743 11.2841 3.06348 10.0333 3.06348C8.78255 3.06348 7.76859 4.07743 7.76859 5.32821V6.54768M14.6851 10.2365L14.0402 6.54768H6.02649L4.63281 15.955H8.90252" stroke="white" stroke-linecap="square"></path>
							<path d="M13.0016 13.9773L11.0234 13.9773M13.0016 13.9773L14.9797 13.9773M13.0016 13.9773L13.002 11.9988M13.0016 13.9773L13.002 15.9551" stroke="var(--white)" stroke-linecap="square"></path>
							</svg>
						</span>
						</div>
					</li>
				`;
				crossSellSliderDesktop.insertAdjacentHTML('beforeend', product_card);
				crossSellSliderMobile.insertAdjacentHTML('beforeend', product_card);
				console.log('product added')
			})

			mmHideLoader();
			
			// Réinitialiser Splide après avoir ajouté les produits
				mmInitSplide();
			} else {
				// Aucun produit trouvé, cacher le loader
				mmHideLoader();
			}
		})
		.catch(error => {
			console.error('Error fetching cross-sell products:', error);
			mmHideLoader();
		});
	}

document.addEventListener("DOMContentLoaded", (event) => {
  mmGetRecoProductsForCrossSell();
});

// DISCOUNT CODES IN CART ========================================================================================= *//

function mmApplyDiscountInCart() {
  const codeInput = document.getElementById("discount-code");
  const newCode = codeInput.value.trim().toLowerCase();
  const errorMessageText = codeInput.dataset.errorText;
  if (!newCode) return;

  let previousCodes = [];

  // --- 1) Récupérer les anciens codes valides ---
  fetch('/cart.js')
    .then(r => r.json())
    .then(cartBefore => {
      previousCodes = (cartBefore.discount_codes || [])
        .filter(d => d.applicable)
        .map(d => d.code.toLowerCase());
    })
    .catch(err => console.error("Impossible de récupérer les codes existants", err))
    .then(() => {
      // --- 2) Essayer d’appliquer tous les codes ---
      const allCodes = Array.from(new Set([...previousCodes, newCode]));

      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          discount: allCodes.join(','),
          sections: mmCartSectionId()
        })
      });
    })
    .then(r => r.json())
    .then(data => {
      // `data` contient le HTML des sections (cart/update.js)
      // On recharge directement le panier avec ce HTML
      refreshCartFromData(data);

      return fetch('/cart.js').then(r => r.json());
    })
    .then(cartAfter => {
      const applied = cartAfter.discount_codes || [];
      const found = applied.find(d => d.code.toLowerCase() === newCode);

      if (found && found.applicable) {
        // ✅ code accepté, rien de plus à faire
        return;
      }

      // ❌ code refusé → restaurer anciens codes
      if (previousCodes.length) {
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: previousCodes.join(',') })
        })
          .then(r => r.json())
          .then(data => {
            refreshCartFromData(data);
            setTimeout(() => displayPromoError(errorMessageText), 1000);
          });
      }

      // Aucun code précédent → juste afficher erreur
      setTimeout(() => displayPromoError(errorMessageText), 1000);
    })
    .catch(err => {
      console.error("Erreur lors de l’application des codes promo", err);

      // Dernier fallback visuel
      setTimeout(() => displayPromoError(errorMessageText), 1000);
    });
}

// Supprimer discount code
function removeDiscount(codeToRemove) {
  if (!codeToRemove) return;

  const codeLower = codeToRemove.trim().toLowerCase();

  // 1) récupérer le panier pour connaître les codes actifs
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {

      // liste des codes actuels encore applicables
      const remainingCodes = (cart.discount_codes || [])
        .filter(d => d.applicable)
        .map(d => d.code.toLowerCase())
        .filter(code => code !== codeLower); // retirer celui demandé

      // 2) réinjecter tous les codes sauf celui retiré
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          discount: remainingCodes.join(','), // push nouvelle liste
          sections: mmCartSectionId()
        })
      });
    })
    .then(res => res.json())
    .then(data => {
      // maj du panier avec les sections renvoyées
      refreshCartFromData(data);
    })
    .catch(err => {
      console.error('Erreur lors du retrait du code promo :', err);
      alert('Erreur lors du retrait.', false);
    });
}



// Affiche un message d’erreur sous le formulaire
function displayPromoError(message) {
  console.log('display')
  let errorElem = document.querySelector('.promo-error');
  if (!errorElem) {
    errorElem = document.createElement('div');
    errorElem.className = 'promo-error text-xs text-red-600 mt-2';
    const discountContainer = document.getElementById('discountContainer');
    discountContainer.appendChild(errorElem);
  }
  errorElem.textContent = message;
}


// Note & Date with LocalStorage

function mmUpdateLocalStorageValue(input) {
	const key = input.dataset.localStorageKey;

	localStorage.setItem(key, input.value);
}

function getValuesFromLocalStorage() {
	// Cart note
	const note_value = localStorage.getItem("mm_note");
	const note_inputs = document.querySelectorAll('.mm-cart-notes');
	note_inputs.forEach(function(note_input) {
		note_input.value = note_value || '';
		// Ajouter un event listener pour mettre à jour le localStorage à chaque frappe
		note_input.addEventListener('input', function() {
			localStorage.setItem("mm_note", note_input.value);
		});
	})

	// Date
	const date_value = localStorage.getItem("mm_date");
	const date_inputs = document.querySelectorAll('.mm-cart-delivery-date');
	date_inputs.forEach(function(date_input) {
		date_input.value = date_value || '';
	})
	
	// Initialiser l'état du bouton après avoir chargé les valeurs
	initDeliveryDateButton();
}

function clearValuesFromLocalStorage() {
	// Supprimer les valeurs du localStorage
	localStorage.removeItem("mm_note");
	localStorage.removeItem("mm_date");

	// Réinitialiser les inputs de note
	const note_inputs = document.querySelectorAll('.mm-cart-notes');
	note_inputs.forEach(function(note_input) {
		note_input.value = '';
	});

	// Réinitialiser les inputs de date
	const date_inputs = document.querySelectorAll('.mm-cart-delivery-date');
	date_inputs.forEach(function(date_input) {
		date_input.value = '';
	});
	
	// Réinitialiser l'état du bouton après avoir vidé les valeurs
	initDeliveryDateButton();
}

// Envoie les notes d'instruction de livraison dans le champ note de la commande
function sendDeliveryInstructions() {
    const checkoutButtons = document.querySelectorAll(".mm-btn-checkout");
    const notesFields = document.querySelectorAll(".mm-cart-notes");

    if (checkoutButtons.length === 0) return;

    checkoutButtons.forEach(button => {
        if (button.hasAttribute('data-delivery-instructions-bound')) return;

        button.setAttribute('data-delivery-instructions-bound', 'true');

        button.addEventListener("click", function (event) {
            event.preventDefault();

            let notesParts = [];

            /* ===============================
            0. Note précommande (automatique)
            =============================== */
            const preorderEl = document.getElementById('mm-cart-preorder-data');
            if (preorderEl?.dataset.hasPreorder === 'true') {
                const items = preorderEl.dataset.preorderItems
                    .split('|')
                    .filter(Boolean)
                    .join(', ');
                notesParts.push(`Commande contenant au moins un produit en précommande (${items})`);
            }

            /* ===============================
            1. Notes client (textarea)
            =============================== */
            for (let i = 0; i < notesFields.length; i++) {
                const field = notesFields[i];
                if (field.value.trim() !== "") {
                    const label =
                        field.closest('.mm-cart-notes-container')
                            ?.querySelector('label')
                            ?.textContent
                            ?.replace(':', '')
                            ?.trim() || 'Notes de livraison';

                    notesParts.push(`${label} : ${field.value.trim()}`);
                    break;
                }
            }

            /* ===============================
            2. Date de livraison différée
            =============================== */
            const deliveryDate = localStorage.getItem("mm_date");

            if (deliveryDate) {
                // deliveryDate attendu au format YYYY-MM-DD
                const [year, month, day] = deliveryDate.split("-");
                const formattedDate = `${day}/${month}/${year}`;

                notesParts.push(`Date de livraison différée : ${formattedDate}`);
            }

            const combinedNotes = notesParts.join("\n");

            fetch("/cart/update.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ note: combinedNotes })
            })
            .then(response => response.json())
            .then(() => {
                clearValuesFromLocalStorage();
                window.location.href = "/checkout";
            })
            .catch(error => {
                console.error("Erreur lors de la mise à jour du panier :", error);
            });
        });
    });
}

/**
 * Intercepte le submit du formulaire de livraison différée pour sauvegarder
 * la date dans localStorage uniquement au moment de la soumission.
 */
function initDeliveryDateForm() {
    const submitButtons = document.querySelectorAll('.mm-cart-delivery-date-submit');
    submitButtons.forEach(function(button) {
        const form = button.closest('form');
        if (!form || form.dataset.deliveryDateFormBound) return;
        form.dataset.deliveryDateFormBound = 'true';
        form.addEventListener('submit', function() {
            const dateInput = form.querySelector('.mm-cart-delivery-date');
            if (dateInput && dateInput.value) {
                localStorage.setItem("mm_date", dateInput.value);
            }
        });
    });
}

/**
 * Active ou désactive le bouton de soumission de date de livraison
 * selon qu'une date est renseignée ou non dans le date picker.
 * 
 * Cette fonction vérifie tous les inputs de date et leurs boutons associés.
 * Si une date est renseignée, le bouton est activé (disabled retiré).
 * Si aucune date n'est renseignée, le bouton reste désactivé (disabled ajouté).
 */
function initDeliveryDateButton() {
	// Trouver tous les inputs de date de livraison
	const dateInputs = document.querySelectorAll('.mm-cart-delivery-date');
	
	// Pour chaque input de date trouvé
	dateInputs.forEach(function(dateInput) {
		// Trouver le bouton submit associé dans le même conteneur
		const dateContainer = dateInput.closest('.mm-cart-delivery-date-container');
		const submitButton = dateContainer ? dateContainer.querySelector('.mm-cart-delivery-date-submit') : null;
		
		// Si le bouton existe, on configure son état
		if (submitButton) {
			// Fonction pour vérifier et mettre à jour l'état du bouton
			function updateButtonState() {
				// Si une date est renseignée (la valeur n'est pas vide)
				if (dateInput.value && dateInput.value.trim() !== '') {
					// Retirer le disabled pour activer le bouton
					submitButton.disabled = false;
				} else {
					// Ajouter le disabled pour désactiver le bouton
					submitButton.disabled = true;
				}
			}
			
			// Vérifier l'état initial du bouton
			updateButtonState();
			
			// Écouter les changements sur l'input de date
			dateInput.addEventListener('input', updateButtonState);
			dateInput.addEventListener('change', updateButtonState);
		}
	});
}

document.addEventListener("DOMContentLoaded", (event) => {
  getValuesFromLocalStorage();
  initDeliveryDateForm();
});